// Generated from UserStats's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'
import type {GrainType} from '../entity/Stats'
import type {GraphType} from '../entity/UserStats'

export type UserStatsCollectionFilterGroups
  = | {
    readonly grain: GrainType | GrainType[]
    readonly graph: GraphType | GraphType[]
    readonly user: Iri | Iri[]
  }
  | {
    readonly grain: GrainType | GrainType[]
    readonly user: Iri | Iri[]
    readonly year?: number | number[] | '*'
  }

export const userStatsCollectionFilterMapping: FilterDefinitionMapping<UserStatsCollectionFilterGroups> = {
  grain: 'grain',
  graph: 'graph',
  user: 'user',
  year: 'year',
}

export type UserStatsCollectionSort = never
